import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Rprogramtemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to R",
        content: ["R basics and syntax", "RStudio environment", "R data types", "R data structures"]
      },
      {
        title: "Data Manipulation with R",
        content: ["Data frames and matrices", "Data cleaning and filtering", "Data aggregation and summarization", "Reshaping data"]
      },
      {
        title: "Data Visualization with R",
        content: ["Basic graphics with base R", "Advanced graphics with ggplot2", "Interactive graphics with Shiny", "Best practices in data visualization"]
      },
      {
        title: "Statistical Analysis with R",
        content: ["Descriptive statistics", "Inferential statistics", "Hypothesis testing", "Regression analysis"]
      },
      {
        title: "Machine Learning with R",
        content: ["Supervised learning", "Unsupervised learning", "Classification and regression", "Dimensionality reduction"]
      },
      {
        title: "Text Analysis with R",
        content: ["Text preprocessing", "Text mining techniques", "Sentiment analysis", "Topic modeling"]
      },
      {
        title: "Web Scraping with R",
        content: ["HTML and CSS basics", "Web scraping libraries", "Regular expressions", "Handling scraped data"]
      },
      {
        title: "Working with APIs in R",
        content: ["JSON and XML data formats", "Accessing APIs with R", "OAuth authentication", "Handling API responses"]
      },
      {
        title: "Debugging and Profiling in R",
        content: ["Debugging techniques", "Profiling code performance", "Memory management", "Code optimization"]
      },
      {
        title: "Parallel Computing with R",
        content: ["Multithreading and parallelism", "Distributed computing with SparkR", "GPU computing with R", "Performance considerations"]
      },
      {
        title: "Building R Packages",
        content: ["Package structure and organization", "Documentation and testing", "Version control with Git", "Publishing and sharing packages"]
      },
      {
        title: "Applications of R",
        content: ["Data science workflows", "Bioinformatics and genomics", "Finance and economics", "Social sciences and humanities"]
      }
    ]

    const faqData = [
      {
        question: 'What is R Programming Training?',
        answer:
          'R Programming Training is a specialized program designed to equip individuals with the skills and knowledge needed to effectively use R for data analysis, statistical computing, and visualization',
      },
      {
        question: 'Why is R Programming Training important?',
        answer:
          'R Programming Training is crucial for professionals seeking to analyze data, create data visualizations, and perform statistical modeling, enabling them to make data-driven decisions and solve complex problems',
      },
      {
        question: 'What topics are covered in R Programming Training at the best training centre?',
        answer:
          'R Programming Training at the best training centre covers a wide range of topics including data manipulation, data visualization, statistical analysis, machine learning, and programming fundamentals in R'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with R programming skills can pursue a variety of career opportunities such as data analyst, data scientist, quantitative analyst, statistical programmer, and research analyst'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into R Programming at the Best Training Centre. Our comprehensive program warmly welcomes individuals from diverse backgrounds, offering them the opportunity to acquire the skills and knowledge necessary to thrive in the world of data analysis and statistical computing using R. Whether you're a data enthusiast, a researcher, or a professional looking to enhance your analytical skills, our courses cater to learners at every level of expertise. With a strong emphasis on practical application and hands-on learning, our expert instructors guide you through essential R Programming concepts, including data manipulation, visualization, statistical modeling, and machine learning. At the Best Training Centre, we prioritize inclusivity and accessibility, ensuring that learners of all backgrounds have the opportunity to excel in mastering R Programming with the best training centre. Join us and unlock your potential in R Programming at the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="R is a programming language for statistical computing and graphics.It used for data analysis, data manipulation, graphics, statistical computing and statistical analysis."/> */}
          <NewMainsec rating='4.1' students={"222"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="R is a programming language for statistical computing and graphics.It used for data analysis, data manipulation, graphics, statistical computing and statistical analysis."/>

         
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`R programming is a popular statistical programming language used for data analysis, machine learning, and more. At Learnsoft.org, we offer top-notch R programming training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of R programming principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to R programming or looking to expand your skillset, Learnsoft.org's R programming ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your R programming journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our R programming course covers a wide range of topics, including data manipulation, data visualization, statistical analysis, and machine learning. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in R programming. By the end of the course, you will be able to apply R programming practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>       
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="Java" coupath2="java" cou='Python' coupath='python' cou10='Full Stack Developer' coupath10='full-stack-developer' cou6='AngularJS' coupath6='angularjs' cou9='Front End Developer' coupath9='front-end-developer'
          cou5='ReactJS' coupath5='reactjs' cou3='JavaScript' coupath3='javascript' cou7='GoCD' coupath7='gocd'
          cou1='DevOps' coupath1='devops' cou8='flutter' coupath8='flutter'  cou4='Go' coupath4='go' />

      </>
    );
  }
}
